<template>
  <div class="lg-datetimepicker">
    <div class="d-flex">
      <b-form-datepicker
        :id="input.id"
        v-model="datePart"
        class="mr-2"
        :required="required"
        :state="state"
        :date-disabled-fn="dateDisabled"
        v-bind="datePickerLabels"
        locale="hu-HU"
      ></b-form-datepicker>
      <b-form-timepicker
        v-model="timePart"
        class="mr-2"
        :required="required"
        :state="state"
        v-bind="timePickerLabels"
        locale="hu-HU"
      >
      </b-form-timepicker>
      <b-button variant="danger" @click="$emit('input', '')" size="sm"><i class="fas fa-trash" /></b-button>
    </div>
  </div>
</template>
<script>
import datePickerLabels from './_datePickerLabels'
import moment from 'moment'

export default {
  props: {
    input: {
      type: Object,
      default: () => ({
        id: '',
        class: 'form-control'
      })
    },
    value: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    state: {
      validator: prop => typeof prop === 'boolean' || prop === null,
      default: null
    },
    isDateDisabled: {
      type: Function,
      default: (date) => {
        const currentDate = new Date(Date.now() - (24*60*60*1000))
        return date < currentDate
      }
    }
  },
  data() {
    return {
      datePickerLabels,
      timePickerLabels: {
        labelHours: 'Óra',
        labelMinutes: 'Perc',
        labelSeconds: 'Másodperc',
        labelIncrement: 'Növelés',
        labelDecrement: 'Csökkentés',
        labelSelected: 'Kiválasztott időpont',
        labelNoTimeSelected: 'és időpontot',
        labelCloseButton: 'Bezárás'
      }
    }
  },
  computed: {
    datePart: {
      get() {
        return moment(this.value, moment.ISO_8601).format(moment.HTML5_FMT.DATE)
      },
      set(value) {
        var date = moment(value, moment.HTML5_FMT.DATE)
        var result = moment(this.value)

        if(!result.isValid()) {
          result = moment(value)
        } else {
          result = result.year(date.year())
                    .month(date.month())
                    .day(date.day())
        }

        var now = moment()
        if(now.isSame(result, 'day') && now.isAfter(result)) {
          result = result.hour(now.hour())
                    .minute(now.minute())
                    .second(now.second())
                    .add(30, 'minute')
        }

        this.$emit('input', result.format('YYYY-MM-DD HH:mm:ss'))
      }
    },
    timePart: {
      get() {
        return moment(this.value, moment.ISO_8601).format(moment.HTML5_FMT.TIME)
      },
      set(value) {
        var time = moment(value, moment.HTML5_FMT.TIME)
        var result = moment(this.value)

        if(!result.isValid()) {
          result = moment()
        }

        result = result.hour(time.hour())
                  .minute(time.minute())
                  .second(time.second())

        this.$emit('input', result.format('YYYY-MM-DD HH:mm:ss'))
      }
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    dateDisabled(ymd, date) {
      const currentDate = new Date(Date.now() - (24*60*60*1000))
      return date < currentDate
    }
  }
}
</script>